import axios from 'axios';
import { downloadFile } from './download-file.service';
import moment from 'moment';

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const reportsNames = {
	registrations: 'registrations',
	goodCallsCount: 'good-calls-count',
	goodCallsAnsweredCount: 'good-calls-answered-count',
	goodCallsAnswerSuccessRate: 'good-calls-answer-success-rate',
	spoofedCallsCountWithCustomers: 'spoofed-calls-count-with-customers',
	spoofedCallsNotAnsweredSuccessRate: 'spoofed-calls-not-answered-success-rate',
	customersUnderAttackCount: 'customers-under-attack-count',
	devicesDistributionRatio: 'devices-distribution-ratio',
	ratingsDistribution: 'ratings-distribution',
};

const API_URL = '/api/v1/reports/';
const REGISTRATIONS_TOTAL_COUNTS_URL = 'registrations-total-counts';
const DOWNLOAD_CSV_URL = 'download-csv';

const getAllReports = (from, to, callCenterId) => {
	return axios.get(
		`${API_URL}`,
		{
			params: {
				from,
				to,
				callCenterId,
			},
		},
	);
};

const getReportsByName = ({
	name,
	from,
	to,
	contactCenterId,
	granularity
}) => {
	const utcFrom = from.toISOString();
	const utcTo = to.toISOString();
	return axios.get(
		`${API_URL}${name}`,
		{
			params: {
				from: utcFrom,
				to: utcTo,
				granularity,
				callCenterId: contactCenterId,
				timeZone,
			},
		},
	);
};

const getRegistrationsTotalCounts = () => axios.get(`${API_URL}${REGISTRATIONS_TOTAL_COUNTS_URL}`);

const downloadReportCsvByName = async ({
	name,
	from,
	to,
	contactCenterId,
	granularity,
}, reportTitle) => {
	const utcFrom = from.toISOString();
	const utcTo = to.toISOString();
	const response = await axios.get(
		`${API_URL}${DOWNLOAD_CSV_URL}`,
		{
			params: {
				from: utcFrom,
				to: utcTo,
				granularity,
				callCenterId: contactCenterId,
				name,
				timeZone,
			},
		},
	);

	const fileCreationTime = moment().format('YYYY-MM-DD_HH-mm-ss');
	downloadFile(response, 'csv', `${reportTitle}_${fileCreationTime}`);
}

export {
	getAllReports,
	getReportsByName,
	getRegistrationsTotalCounts,
	downloadReportCsvByName,
	reportsNames,
};
